<template>
  <div class="status-messages">
    <div
      v-if="
        assignment.status_messages['verify-2'] &&
        assignment.status !== 'Approved'
      "
      class="status-message status-message-verifying"
    >
      <p>
        Unfortunately, we weren't able to verify the review of your previous
        reader. We're looking for a new reader for you now, and have placed your
        book at the top of our library page in order to find one as quickly as
        possible. We are very sorry for the delay.
      </p>
    </div>

    <div
      v-else-if="
        assignment.status_messages['verifying-1'] &&
        assignment.status !== 'Approved'
      "
      class="status-message status-message-verifying"
    >
      <p>
        We haven't been able to verify that this review is published on
        Amazon yet. We have reached out to your reviewer to work with them
        to get it published as soon as possible.
      </p>
      <p>
        If we are unable to verify that this review has been published by
        <span class="date">{{ assignment.status_messages["verifying-1"] }}</span
        >, we will place your book at the top of our library page in order to
        find a new reader as quickly as possible. We are very sorry for this
        delay.
      </p>
    </div>

    <div
      v-else-if="
        assignment.status_messages['vp-reconciled'] &&
        assignment.status === 'Approved'
      "
      class="status-message status-message-verifying"
    >
      <p>
        This review was published and approved. However, it was not stamped as a
        Verified Purchase review on Amazon. This is most likely due to a
        mistake by your reviewer.
      </p>
      <p>
        You spent an additional
        {{ assignment.status_messages["vp-reconciled"] }} snaps for the VP
        option on this review, so we have returned those snaps to your account.
      </p>
    </div>

    <div
      v-else-if="
        assignment.status_messages['overdue'] &&
        assignment.status === 'Assigned'
      "
      class="status-message status-message-verifying"
    >
      <p>
        Your reader is late to turn in their review. We have reached out to them
        and have asked that they turn in their review as soon as possible.
      </p>
      <p>
        If your reader does not turn in their review by
        <span class="date">9:00pm EST today</span>, we will place your book at
        the top of our library page in order to find a new reader as quickly as
        possible. We are very sorry for this delay.
      </p>
    </div>

    <div
      v-else-if="
        assignment.status_messages['cancel'] && assignment.status === 'Open'
      "
      class="status-message status-message-verifying"
    >
      <p>
        Unfortunately, your previous reader had to cancel their assignment to
        read your book. We have placed your book near the top of our library
        page in order to find you a new reader as soon as possible. We are very
        sorry for the delay.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusMessages",
  components: {},
  props: ["assignment"],
  data: function () {
    return {};
  },
  created() {
    // console.log("assignment", this.assignment);
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.status-message {
  margin-top: 12px;
  margin-bottom: 12px;
  background: lighten(#daedff, 3%);
  color: darken(#2196f3, 30%);
  padding: 12px 18px 2px 18px;
  border-radius: 12px;
  font-size: 11pt;
}

.date {
  font-weight: 600;
}
</style>
